<style lang="scss" scoped>
@import '$vars';

.title {
  font-size: 1.5rem;
  padding: 0.15rem 0 0 0;
}

.modal-form {
  &__title {
    @apply flex flex-row items-center justify-start;
    font-size: 1.25rem;

    .icon {
      @apply mr-1;
      max-height: 1.25rem;
      max-width: 1.25rem;
    }
  }
}

.cta {
  @apply text-white p-2 rounded rounded-full w-full mb-4;
  @apply text-base;
  background-color: $color-green;
  font-family: $font2;
  transition: all 0.5s ease;

  &:hover {
    background-color: darken($color-green, 8%);
    transition: all 0.2s ease;
  }

  &--alt {
    background: #FFF7E7;
    border: 2px solid $color-yellow;
    color: #444;

    &:hover {
      background-color: darken(#fff7e7, 10%);
    }

    span {
      color: #CCAC66;
    }
  }
}

.cancel {
  @apply flex items-center justify-center;
  border-color: $color-blue !important;
  border: 2px solid;

  &:hover {
    background-color: lighten($color-blue, 35%) !important;
  }
}

.modal-container {
  width: 42.5rem;
}
</style>

<template>
  <transition name="fade" mode="out-in">
    <div
      v-if="plan.showModal"
      v-scroll-lock="plan.showModal"
      class="modal active"
    >
      <div class="modal-overlay" />

      <section class="modal-container appointment-simple">
        <header class="modal-header modal-form__header">
          <a
            class="btn btn-clear float-right modal-form__close"
            aria-label="close"
            @click="close"
          >
          </a>

          <template v-if="!plan.isReminderModal">
            <h1 class="modal-form__title title mb-0">
              <dr-icon
                name="padlock"
                color="rgb(86, 189, 210)"
                class="icon"
              />

              Funcionalidade bloqueada
            </h1>
          </template>

          <template v-if="plan.isReminderModal">
            <h1 class="modal-form__title title mb-0">
              <dr-icon
                name="bell"
                color="rgb(86, 189, 210)"
                class="icon"
              />

              Lembrete
            </h1>
          </template>
        </header>

        <article class="modal-body modal-form__body mt-0 pt-0">
          <div>
            <button
              :class="{ 'cta--alt': plan.isReminderModal }"
              class="cta"
              @click="
                close();
                $router.push({ name: 'DoctorPlans' })
              "
            >
              <template v-if="!plan.isReminderModal">
                Faça upgrade para usufruir desse recurso
              </template>

              <template v-if="plan.isReminderModal">
                Seu período de degustação termina em
                <span class="font-bold">{{ plan.remainingDays }}</span> dias
              </template>
            </button>
          </div>

          <p class="text-center">
            Conheça as vantagens exclusivas do plano <strong class="uppercase text-green">PREMIUM</strong>
            e continue tendo acesso pleno à plataforma Dr. Conecta para tornar seu consultório ainda
            mais completo.
          </p>

          <ul class="px-12 text-blueAlt list-none">
            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Agenda Online
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Prontuário Eletrônico Customizável
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Prescrição Digital Automatizada para Medicamentos e Exames
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Certificado Digital para garantir a autenticidade dos documentos
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Prescrição de Atestados com tabela CID 10
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Relatórios de desempenho
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Módulo Financeiro
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Integração com Google Agenda
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Receba mais pacientes com o nosso Market Place
            </li>

            <li class="flex items-center justify-start">
              <dr-icon
                name="checkAlt"
                color="#444444"
                class="icon mr-2"
              />
              Consultório Virtual e Atendimento via Telemedicina
            </li>

          </ul>
        </article>

        <footer class="modal-form__footer flex flex-row items-center justify-between mb-4 px-2">
          <button
            class="btn btn-white cancel"
            @click="close"
          >
            Agora não
          </button>

          <button
            class="btn btn-primary"
            @click="
              close();
              $router.push({ name: 'DoctorPlans' })
            "
          >
            <template v-if="!plan.isReminderModal">
              Fazer upgrade
            </template>

            <template v-if="plan.isReminderModal">
              Gostei, quero fazer o upgrade
            </template>
          </button>
        </footer>
      </section>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/globals/eventBus'

export default {
  name: 'UpgradePlanModal',

  computed: {
    ...mapGetters({ plan: 'getPlan' })
  },

  created () {
    this.fn_HIDE_PROGRESS()

    EventBus.$on('show-premium-remaining-days', this.checkRemainingDays)
  },

  methods: {
    close () {
      const showModal = false
      const isReminderModal = false
      this.$store.dispatch('togglePlanModal', { showModal, isReminderModal })
    },

    checkRemainingDays () {
      if (this.plan.isPremium) {
        const url = '/doctor/doctor_subscription_plan/remaining_trial_days'

        this.$http
          .get(url, this.$store.getters.getAuthHeader)
          .then((res) => {
            if (res.data) {
              const remainingDays = res.data.replace(/\D/gmi, '')
              const isReminderModal = true
              const showModal = true

              this.$store.dispatch('setPlan', { remainingDays, isReminderModal, showModal })
            }
          })
      }
    }
  }
}
</script>

<style>

</style>
